import React from 'react';

import { BuildDomain } from 'src/enums/build/build-domain';

export const getAmplitudeKey = (buildDomain: BuildDomain) =>
  buildDomain === BuildDomain.TOGETHER_FOUNDATION
    ? process.env.GATSBY_TOGETHER_FOUNDATION_AMPLITUDE_API_KEY
    : process.env.GATSBY_AMPLITUDE_API_KEY;

/**
 * Amplitude is initialised client-side after analytics consent is checked.
 * @see onClientEntry
 */
const Amplitude: React.FC = () => (
  <>
    <link rel="dns-prefetch" href="https://sr-client-cfg.eu.amplitude.com" />
    <link rel="preconnect" href="https://cdn.eu.amplitude.com" />
  </>
);

export default Amplitude;
